import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { useLpTransferDeleteImpact } from '@/hooks/react-query/useFundTransactions';

import { LpTransferImpactSummary } from './LpTransferImpactSummary';

export function DeleteLpTransferDialog({
  open,
  onOpenChange,
  fundId,
  fundTransactionId,
  transferorName,
  onDelete,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  fundId: string;
  fundTransactionId: string;
  transferorName: string | undefined;
  onDelete: () => Promise<void>;
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <DeleteConfirmation
          fundId={fundId}
          fundTransactionId={fundTransactionId}
          transferorName={transferorName}
          onDelete={onDelete}
        />
      </AlertDialogContent>
    </AlertDialog>
  );
}

// Mounted only while the dialog is open, so the impact is fetched on open.
function DeleteConfirmation({
  fundId,
  fundTransactionId,
  transferorName,
  onDelete,
}: {
  fundId: string;
  fundTransactionId: string;
  transferorName: string | undefined;
  onDelete: () => Promise<void>;
}) {
  const impact = useLpTransferDeleteImpact(fundId, fundTransactionId);
  const isUnblocked = impact.data?.blockers.length === 0;

  return (
    <>
      <AlertDialogHeader>
        <AlertDialogTitle>Delete this draft transfer?</AlertDialogTitle>
        <AlertDialogDescription>
          The commitment goes back to {transferorName} and its draft journal
          entry is removed.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <LpTransferImpactSummary fundId={fundId} query={impact} />
      <AlertDialogFooter>
        <AlertDialogCancel>Keep the draft</AlertDialogCancel>
        <AlertDialogAction
          onClick={onDelete}
          disabled={!isUnblocked}
          className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
        >
          Delete draft
        </AlertDialogAction>
      </AlertDialogFooter>
    </>
  );
}
